import Container from './my-profile-container';

export default Container;
